module.exports = __webpack_public_path__ + "static/media/Jirachi_gaussian2.7ad0d631.png";